import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../lib/api';

/**
 * 현재 사용자의 피처 플래그 평가 결과를 가져오는 훅.
 * 5분 캐시, 1분마다 백그라운드 리프레시.
 */
export function useFeatureFlags() {
  const { data, error } = useQuery({
    queryKey: ['feature-flags', 'me'],
    queryFn: () => adminApi.getMyFeatureFlags(),
    staleTime: 5 * 60 * 1000,
    refetchInterval: 60 * 1000,
    retry: 1,
  });

  if (error) {
    console.warn('[useFeatureFlags] 피처 플래그 조회 실패:', error);
  }

  const flags = (data?.success ? data.data : null) ?? {};

  return {
    flags,
    isEnabled: (key: string) => flags[key] === true,
  };
}
